import {AppFromBackapi} from '@utils/fetchAppsByPackageNames';
import Image from 'next/image';

import styles from './Pick.module.scss';

export default function Pick({pick}: {pick: AppFromBackapi}) {
  return (
    <div className={styles.pick}>
      <Image
        alt=""
        className={styles.icon}
        src={pick.iconUrl}
        width={70}
        height={70}
      />
      <span className={styles.appName} id={pick.packageName}>
        {pick.appName}
      </span>
    </div>
  );
}
